<template>
  <div class="report-content bg-white pa-30px br-10px">
    <ReportTabs :sections="sections" :active-tab="activeTab" @update:active-tab="emit('update:active-tab', $event)" />

    <ReportSolutions v-if="activeTab === 'solutions'" :report="report" />
    <RunoffAnalysis v-else-if="activeTab === 'runoff'" :report="report" />
    <MarkdownRenderer v-else :content="sectionContent" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import ReportTabs from "@/views/ReportDetailsView/components/ReportTabs.vue";
import RunoffAnalysis from "@/views/ReportDetailsView/components/RunoffAnalysis.vue";
import ReportSolutions from "@/views/ReportDetailsView/components/ReportSolutions.vue";
import MarkdownRenderer from "@/components/MarkdownRenderer.vue";

const props = defineProps({
  report: {
    type: Object,
    required: true,
  },
  activeTab: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["update:active-tab"]);

const sections = computed(() => props.report.sections);
const section = computed(() => sections.value.find((s) => s.id === props.activeTab));

const sectionContent = computed(() => {
  if (!section.value) return "";
  return section.value.content;
});
</script>

<style lang="scss" scoped>
.report-content {
  flex: 1;
  min-width: 0;

  @media (max-width: 768px) {
    padding: 10px
  }
}
</style>
